// extracted by mini-css-extract-plugin
export var bottom = "Footer-module--bottom--Pi1Z3";
export var container = "Footer-module--container--V-T-b";
export var cvr = "Footer-module--cvr--VRx6T";
export var left = "Footer-module--left--cEYRs";
export var links = "Footer-module--links--QrauF";
export var main = "Footer-module--main--1a3r6";
export var middle = "Footer-module--middle--whfs8";
export var right = "Footer-module--right--+1Ni3";
export var wrapper = "Footer-module--wrapper--JEjoz";